<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    class="edit-icon"
    :style="{ '--icon-color': color }"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path
      d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"
    />
  </svg>
</template>

<script setup>
defineProps({
  size: {
    type: [String, Number],
    default: 16,
  },
  color: {
    type: String,
    default: '#0088cc',
  },
})
</script>

<style scoped>
.edit-icon {
  display: inline-block;
  vertical-align: middle;
  transition: opacity 0.2s;
  color: var(--icon-color, #0088cc);
}

.edit-icon:hover {
  opacity: 0.8;
}
</style>

<style>
/* Make icon white when inside buttons */
a.btn-link .edit-icon,
a.btn-sm .edit-icon,
button.btn-sm .edit-icon,
button.btn-primary .edit-icon {
  color: white !important;
}
</style>
